import React, { useId } from "react";
import LeadFormPanel from "./landing/lead-form/LeadFormPanel";
import { EnquiryType } from "./landing/lead-form/content";
import { CONTAINER } from "./landing/ui";

type Props = {
  enquiryType: EnquiryType;
  homeUrl: string;
};

// The dialog twin of the CTAs, for the links in our own emails and PDF, where a dialog cannot be
// opened. Same panel, no overlay.
export default function SpeakToUsPage({ enquiryType, homeUrl }: Props) {
  const headingId = useId();

  return (
    <div className={`${CONTAINER} tw-py-20 sm:tw-py-12`}>
      <div className="tw-mx-auto tw-max-w-3xl tw-overflow-hidden tw-rounded-[28px] tw-border tw-border-[#c9deef] tw-bg-white tw-shadow-[0_24px_70px_rgba(23,72,111,.12)]">
        <LeadFormPanel
          request={{ enquiryType }}
          headingId={headingId}
          headingLevel={1}
          layout="stacked"
          onDone={() => window.location.assign(homeUrl)}
          doneLabel="Back to FutureLab"
        />
      </div>
    </div>
  );
}
